import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';

const CenteredCol = props => (
    <Col xs={12}>
        <Row center="xs">
            {props.children}
        </Row>
    </Col>
);

export default CenteredCol;


// WEBPACK FOOTER //
// ./src/components/shared/CenteredCol.js